import { ServicePluginDefinition } from '@wix/sdk-types';
import {
  Context,
  ListTriggersRequest,
  ListTriggersResponse,
  GetEligibleTriggersRequest,
  GetEligibleTriggersResponse,
} from './service-plugins-types.js';
import {
  renameKeysFromSDKRequestToRESTRequest,
  renameKeysFromRESTResponseToSDKResponse,
} from '@wix/sdk-runtime/rename-all-nested-keys';

export interface ListTriggersEnvelope {
  request: ListTriggersRequest;
  metadata: Context;
}

export interface GetEligibleTriggersEnvelope {
  request: GetEligibleTriggersRequest;
  metadata: Context;
}

export const provideHandlers = ServicePluginDefinition<{
  /**
   *
   * Lists all custom triggers provided by your service plugin integration.
   *
   * This method is automatically called by Wix eCommerce to populate the custom [minimum requirements section of an automatic discount](https://support.wix.com/en/article/wix-stores-creating-automatic-discounts#:~:text=Create%20minimum%20requirements). */
  listTriggers(
    payload: ListTriggersEnvelope
  ): ListTriggersResponse | Promise<ListTriggersResponse>;

  /**
   *
   * Retrieves eligible custom discount triggers based on the provided items.
   *
   * This method is automatically called by Wix eCommerce to retrieve the custom discount triggers provided by your extension.
   * This happens when actions are performed on the cart and checkout entities/pages. For example, when an item is added to the cart. */
  getEligibleTriggers(
    payload: GetEligibleTriggersEnvelope
  ): GetEligibleTriggersResponse | Promise<GetEligibleTriggersResponse>;
}>('ECOM_DISCOUNTS_TRIGGER', [
  {
    name: 'listTriggers',
    primaryHttpMappingPath: '/v1/list-triggers',
    transformations: {
      toREST: (payload: any) => {
        const toRestResponse = payload;

        return renameKeysFromSDKRequestToRESTRequest(toRestResponse);
      },
      fromREST: (payload: any) => {
        const fromRestRequest = payload;

        return renameKeysFromRESTResponseToSDKResponse(fromRestRequest);
      },
    },
  },

  {
    name: 'getEligibleTriggers',
    primaryHttpMappingPath: '/v1/get-eligible-triggers',
    transformations: {
      toREST: (payload: any) => {
        const toRestResponse = payload;

        return renameKeysFromSDKRequestToRESTRequest(toRestResponse);
      },
      fromREST: (payload: any) => {
        const fromRestRequest = payload;

        return renameKeysFromRESTResponseToSDKResponse(fromRestRequest);
      },
    },
  },
]);
